import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { type ScheduleConfigDto } from '@api/devices';


@Component({
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  selector: 'avs-schedule-info',
  templateUrl: './schedule-info.component.html',
})
export class ScheduleInfoComponent {
  scheduleConfig = input<ScheduleConfigDto | null | undefined>();
  scheduleEnabled = input<boolean>(false);

  protected summary = computed(() => {
    const workingHours = this.scheduleConfig()?.workingHours ?? {};
    const days = Object.keys(workingHours).map(Number).sort((a, b) => a - b);

    if (days.length === 0) return '';

    const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const groups: number[][] = [];

    let currentGroup = [days[0]];

    for (let i = 1; i < days.length; i++) {
      if (days[i] === days[i - 1] + 1) {
        currentGroup.push(days[i]);
      } else {
        groups.push(currentGroup);
        currentGroup = [days[i]];
      }
    }
    groups.push(currentGroup);

    const daySummary = groups.map(group => {
      if (group.length === 1) {
        return dayNames[group[0] - 1];
      } else {
        return `${dayNames[group[0] - 1]}-${dayNames[group[group.length - 1] - 1]}`;
      }
    }).join(', ');

    const firstDay = days[0].toString();
    const timeRange = workingHours[firstDay];
    const timeSummary = `${timeRange.start} - ${timeRange.end}`;

    return `${daySummary} ${timeSummary}`;
  });
}
